<template>
    <b-container id="Learning" class="Learning wrapper">
        <b-row id="triggerCapacity2">
            <b-col cols="12">
                <h2 class="tac">{{$t('Learning.msg')}}</h2>
                <p class="learningP">{{$t('Learning.sub')}}</p>
            </b-col>
        </b-row>

        <b-row id="triggerCapacity3">
            <b-col v-for="(capacity, i) in myJson.capacities" :key="i" cols=12 sm="6" class="capacities">
                <Capacity
                    :anim="'animCapacity'+i" 
                    :msg="$t('Learning.capacities['+i+'].msg')"
                    :details="$t('Learning.capacities['+i+'].details')"/>
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="12" class="footerLearning">
                <p>{{$t('Learning.submsg')}}</p>
                <DiscussBtn />
            </b-col>
        </b-row>
    </b-container>
</template> 

<script>
import Capacity from "@/components/home/Capacity.vue"
import DiscussBtn from "@/components/DiscussBtn.vue"
import json from '@/locales/en.json'

export default {
    name: 'Learning',
    data: function() {
        return {
            myJson: json.Learning
        }
    }, 
    components: {
        Capacity,
        DiscussBtn
    }
}
</script>

<style scoped lang="scss">
@import '@/assets/style/learning.scss';
</style>